import { render, staticRenderFns } from "./type.vue?vue&type=template&id=19acef6c&scoped=true&"
import script from "./type.vue?vue&type=script&lang=js&"
export * from "./type.vue?vue&type=script&lang=js&"
import style0 from "./type.vue?vue&type=style&index=0&id=19acef6c&prod&lang=less&scoped=true&"
import style1 from "./type.vue?vue&type=style&index=1&id=19acef6c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19acef6c",
  null
  
)

export default component.exports